(function () {
    'use strict';

    const DEFAULT_PARAMS = {
        isDarkTheme: false,
        view: 'bnpl-widget-five',
        price: 0,
    };

    let lockedOverlay = null;
    let bodyOverflow = '';

    function getOtpHost() {
        return document.querySelector('.otp-bnpl-modal-host') || document.querySelector('#otp-widget-bnpl');
    }

    function isOtpOverlay(node) {
        return (
            node instanceof HTMLElement &&
            node !== getOtpHost() &&
            getComputedStyle(node).position === 'fixed' &&
            (node.textContent || '').includes('равных платежа')
        );
    }

    function lockPageScroll(overlay) {
        if (lockedOverlay) {
            return;
        }

        lockedOverlay = overlay;
        bodyOverflow = document.body.style.overflow;
        document.documentElement.classList.add('scroll-lock');
        document.body.classList.add('scroll-lock');
        document.body.style.overflow = 'hidden';
    }

    function unlockPageScroll() {
        if (!lockedOverlay) {
            return;
        }

        lockedOverlay = null;
        document.documentElement.classList.remove('scroll-lock');
        document.body.classList.remove('scroll-lock');
        document.body.style.overflow = bodyOverflow;
    }

    function syncPageScroll() {
        const overlay = [...document.body.children].find(isOtpOverlay) || null;

        if (overlay) {
            lockPageScroll(overlay);
            return;
        }

        unlockPageScroll();
    }

    new MutationObserver(syncPageScroll).observe(document.body, {childList: true});

    function openDavayDelitModal(price) {
        const host = getOtpHost();
        if (!host) {
            return;
        }

        host.dataset.params = JSON.stringify({
            ...DEFAULT_PARAMS,
            price: Number(price) || 0,
        });

        setTimeout(() => {
            host.querySelector('.bnpl-widget')?.click();
        }, 0);
    }

    document.addEventListener('click', (event) => {
        const button = event.target.closest('.js-davay-delit-info');
        if (!button) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        openDavayDelitModal(button.dataset.price);
    });
})();
